import React from 'react';
import { Window } from 'react-components';

export interface MicroAppProps {
  key: string;
  onClose?: () => void;
  children?: React.ReactNode;
}

export function createMicroApp(
  title: string | React.ReactElement,
  Component: React.ComponentType<{}>,
): React.MemoExoticComponent<
  React.ForwardRefExoticComponent<
    React.PropsWithoutRef<MicroAppProps> & React.RefAttributes<HTMLDivElement>
  >
> {
  return React.memo(
    React.forwardRef(
      (
        { children, ...otherProps }: React.PropsWithChildren<MicroAppProps>,
        ref: React.Ref<HTMLDivElement>,
      ) => (
        <Window ref={ref} title={title} {...otherProps}>
          <Component />
          {children}
        </Window>
      ),
    ),
  );
}
